import React from 'react';
import ContentPage from '../ContentPage/ContentPage';

const ShippingPage: React.FC = () => <ContentPage slug="versand" title="Versand" />;

export default ShippingPage;
